import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/NewsletterSection.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/image-component.js");
